import React from "react";
import { observer } from "mobx-react";
import {
  generatePath,
  useNavigate,
  useParams,
} from "react-router-dom";

import WorkoutDetailsStore from "stores/WorkoutDetailsStore";

import { NavListItem } from "components/Layout";
import { NavLinkItemType } from "components/Layout/NavListItem/NavListItem";

import { capitalize } from "utils/common";

import ROUTES from "navigation/routes";
type Props = { workoutLabel?: string };

const NavList: React.FC<Props> = observer(() => {
  const navigate = useNavigate();
  const params = useParams<{
    workoutId?: string;
    movementId?: string;
    scheduleDate?: string;
  }>();
  const workoutId = params.workoutId ? Number.parseInt(params.workoutId) : undefined;
  const scheduleDate = params.scheduleDate;
  const movementId = params.movementId ? Number.parseInt(params.movementId) : undefined;

  const onClick = (route: string, routeParams?: any) => () => {
    navigate(generatePath(route, routeParams));
  };

  const firstItem: NavLinkItemType = {
    title: "Calendar",
    onClick: onClick(ROUTES.CALENDAR),
  };

  const workoutTitle = React.useMemo(
    () =>
      WorkoutDetailsStore.details?.title
        ? capitalize(WorkoutDetailsStore.details?.title)
        : undefined,
    [WorkoutDetailsStore.details?.title]
  );

  const movementTitle = React.useMemo(
    () =>
      movementId
        ? capitalize(
            WorkoutDetailsStore.getMovementDetails(movementId)?.title,
          )
        : undefined,
    [movementId]
  );

  const navListItems = React.useMemo(() => {
    if (workoutId) {
      const secondItem = workoutId
        ? {
            title: workoutTitle,
            onClick: onClick(
              ROUTES.CALENDAR_WORKOUT_SCHEDULE_DATE_DETAILS,
              {
                workoutId,
                scheduleDate,
              },
            ),
          }
        : undefined;

      const thirdItem = movementId
        ? {
            title: movementTitle,
            onClick: onClick(
              ROUTES.CALENDAR_WORKOUT_SCHEDULE_DATE_DETAILS_MOVEMENT_DETAILS,
              {
                workoutId,
                movementId,
                scheduleDate,
              },
            ),
          }
        : undefined;

      return [firstItem, secondItem, thirdItem].filter(Boolean);
    }
    return [];
  }, [workoutId, movementId, scheduleDate, workoutTitle, movementTitle]);

  return (
    <>
      {navListItems.map((item: any, index: number) => (
        <NavListItem
          key={`${index}-${item.title}`}
          title={item.title}
          onClick={item.onClick}
          isLastItem={index === navListItems.length - 1}
        />
      ))}
    </>
  );
});

export default NavList;
